import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=0c5e48cf&scoped=true"
import script from "./userdetail.vue?vue&type=script&lang=js"
export * from "./userdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e48cf",
  null
  
)

export default component.exports